import { Link } from 'react-router-dom';
import { categories, newsItems } from '@/mocks/articles';

export default function QuickLinks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-6">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
                  资讯速览
                </h2>
                <p className="text-sm text-foreground-500">最近的重要消息一览</p>
              </div>
            </div>
            <div className="space-y-3">
              {newsItems.slice(0, 5).map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors group"
                >
                  <div className="w-16 h-16 rounded-lg overflow-hidden shrink-0">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mt-0.5">
                      {item.title}
                    </p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400 shrink-0"></i>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
                快速导航
              </h2>
              <p className="text-sm text-foreground-500">选择你感兴趣的板块</p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center justify-center gap-2 p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group text-center"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}